function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "transactions_svg__a",
  opacity: 1,
  d: "M2 0h14v1H2z"
}), React.createElement("path", {
  id: "transactions_svg__b",
  opacity: 1,
  d: "M2 9h14v1H2z"
}), React.createElement("path", {
  id: "transactions_svg__c",
  opacity: 1,
  d: "M2 3h12.444v1H2z"
}), React.createElement("path", {
  id: "transactions_svg__d",
  opacity: 1,
  d: "M2 6h12.444v1H2z"
}), React.createElement("path", {
  id: "transactions_svg__e",
  opacity: 1,
  d: "M2 12h12.444v1H2z"
}), React.createElement("path", {
  id: "transactions_svg__f",
  opacity: 1,
  d: "M2 15h12.444v1H2z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("use", {
  xlinkHref: "#transactions_svg__a",
  fill: "#8395B7"
});

var _ref4 =
/*#__PURE__*/
React.createElement("use", {
  xlinkHref: "#transactions_svg__b",
  fill: "#8395B7"
});

var _ref5 =
/*#__PURE__*/
React.createElement("use", {
  xlinkHref: "#transactions_svg__c",
  fill: "#8395B7"
});

var _ref6 =
/*#__PURE__*/
React.createElement("use", {
  xlinkHref: "#transactions_svg__d",
  fill: "#8395B7"
});

var _ref7 =
/*#__PURE__*/
React.createElement("use", {
  xlinkHref: "#transactions_svg__e",
  fill: "#8395B7"
});

var _ref8 =
/*#__PURE__*/
React.createElement("use", {
  xlinkHref: "#transactions_svg__f",
  fill: "#8395B7"
});

var SvgTransactions = function SvgTransactions(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    height: 18,
    width: 18,
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTransactions, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/transactions.34b62be9.svg";
export { ForwardRef as ReactComponent };